<template>
  <InnerContainer :title="templateData.pageTitle" :sub-title="templateData.problem">
    <template #default>
      <div class="exercise-container">
        <!-- 循环展示题目 -->
        <div
          v-for="(question, index) in templateData.content[0].count1List"
          :key="index"
          class="question-card"
        >
          <!-- 题目编号和内容 -->
          <div class="question-header">
            <span class="question-text" v-html="processContent(question.question)"></span>
            <img
              class="analysis-icon"
              :src="question.showAnalysis ? IconActiveAnalysis : IconAnalysis"
              alt="分析"
              @click="toggleAnalysis(index)"
            />
          </div>

          <!-- 选项列表 -->
          <div class="options-list">
            <div
              v-for="option in question.count2List"
              v-show="option.option || option.optionContent"
              :key="option.key"
              class="option-item"
              :class="{
                'correct-answer': option.option == question.answer && question.showAnalysis,
                'highlight-green':option.showResult && option.option == question.answer,
                'highlight-red':option.showResult && option.option != question.answer,
              }"
              @click="handleAnswer(question.answer,option,$event)"
            >
              <span v-if="option.option" class="option-key"
                >{{ option.option
                }}<span v-if="option.option && option.optionContent">.</span></span
              >
              <span v-if="option.optionContent" class="option-text">{{
                option.optionContent
              }}</span>
            </div>
          </div>

          <!-- 答案和解析 -->
          <div v-if="question.showAnalysis" class="answer-section">
            <div class="answer-header">
              <img class="lightbulb-icon" src="@/assets/grammar/right_tips.png" alt="正确答案" />
              <span class="correct-answer-text">正确答案: {{ question.answer }}</span>
            </div>
            <div class="explanation">
              <span class="explanation-text">{{ question.answerAnalysis }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </InnerContainer>
</template>

<script setup lang="ts">
import InnerContainer from "@/views/grammar/newGrammar/components/InnerContainer.vue";
import IconAnalysis from "@/assets/grammar/icon_analysis.png";
import IconActiveAnalysis from "@/assets/grammar/active_analysis.png";
import { ref, defineProps } from "vue";
const props = defineProps({
  templateData: {
    type: Object,
    required: true,
  },
});

// 切换显示解析
function toggleAnalysis(index: any) {
  props.templateData.content[0].count1List[index].showAnalysis =
    !props.templateData.content[0].count1List[index].showAnalysis;
}

// 处理内容中的特殊标签
const processContent = (content) => {
  return content
    .replace(/<r>/g, '<span class="highlight-red">')
    .replace(/<\/r>/g, "</span>")
    .replace(/<l>/g, '<span class="highlight-blue">')
    .replace(/<\/l>/g, "</span>")
    .replace(/<y>/g, '<span class="highlight-yellow">')
    .replace(/<\/y>/g, "</span>")
    .replace(/<bl>/g, '<span class="highlight-blue">')
    .replace(/<\/bl>/g, "</span>")
    .replace(/<g>/g, '<span class="highlight-green">')
    .replace(/<\/g>/g, "</span>")
    .replace(/<u>/g, "<u>")
    .replace(/<\/u>/g, "</u>")
    .replace(/<b>/g, "<strong>")
    .replace(/<\/b>/g, "</strong>")
    .replace(/<i>/g, "<em>")
    .replace(/<\/i>/g, "</em>")
    .replace(/<br\/>/g, "<br/>");
};

const handleAnswer = (answer,opt,ev)=>{
  opt.showResult = !opt.showResult;
}
</script>

<style scoped lang="less">
.exercise-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.question-card {
  background: #fff;
  border-radius: 0.5rem;
  padding: 1rem;
  color: #3f4140;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-weight: 400;
}

.question-header {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.question-number {
  font-weight: 700;
  font-size: 1.1rem;
  color: #3f4140;
}

.question-text {
  display: inline-block;
  flex: 1;
  font-size: 1.15rem;
  font-weight: 400;
  line-height: 1.6rem;
  word-break: break-word;
}

.analysis-icon {
  width: 1.3rem;
  height: 1.3rem;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.analysis-icon:hover {
  opacity: 1;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.option-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.4rem 0;
  border-radius: 0.3rem;
  transition: background-color 0.2s ease;
}

.option-item:hover {
  background-color: #f5f5f5;
}

.option-item.correct-answer {
  color: #0dcb8b;
  font-weight: 600;
}

.option-key {
  font-weight: 400;
  min-width: 1.5rem;
  font-size: 1.15rem;
}

.option-text {
  flex: 1;
  line-height: 1.5rem;
  font-size: 1.15rem;
}

.answer-section {
  background: #f0f9f6;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-top: 1rem;
  border: 0.15rem solid #0dcb8b;
}

.answer-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 1.1rem;
  padding: 0.27rem 0.81rem;
  margin-bottom: 0.8rem;
  width: fit-content;
  background-color: #ffddb3;
}

.lightbulb-icon {
  width: 0.74rem;
  height: 0.95rem;
}

.correct-answer-text {
  font-weight: 600;
  color: #ff8c00;
  font-size: 1rem;
}

.explanation {
  display: flex;
  gap: 0.5rem;
}

.explanation-text {
  flex: 1;
  line-height: 1.6rem;
  color: #676767;
  font-size: 1.15rem;
  word-break: break-word;
}
.show-result{
  color: #0dcb8b;
}
.show-error-result{
  color: #dc3545;
}
</style>
